import { css } from '@/styled-system/css';

export const assistChipLoadingStyles = css.raw({
  marginInlineEnd: 'tighter',
  display: 'flex',
  alignItems: 'center',
});
